import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {AssinantesModel} from "./assinantes.model";
import {AssinantesService} from './assinantes.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {UsuariosCargosService} from '../usuarios-cargos/usuarios-cargos.service';
import {UsuariosService} from '../usuarios/usuarios.service';
import {MercadoriasService} from '../mercadorias/mercadorias.service';
import {MercadoInternoMercadoriasService} from '../mercado-interno-mercadorias/mercado-interno-mercadorias.service';

declare let swal: any;

@Component({
  selector: 'app-assinantes-form',
  templateUrl: './assinantes-form.component.html'
})
export class AssinantesFormComponent implements OnInit {

  enviandoForm = false;
  form: FormGroup;
  title: string;
  assinante: AssinantesModel = new AssinantesModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;

  carregandoTabela: boolean = true;

  listUsuarios = [];
  listMercadorias = [];

  srcImgAssinatura = "";
  urlUploadAssinatura = "";
  urlUploadCertificado = "";

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private assinantesService: AssinantesService,
    private usuariosService: UsuariosService,
    private mercadoriasService: MercadoriasService,
    private mercadoInternoMercadoriasService: MercadoInternoMercadoriasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {

    this.form = formBuilder.group({
      id_assinante: [],
      id_usuario: ['', [
        Validators.required
      ]],
      cgc_mapa: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      img_assinatura: [],
      certificado: [],
      senha: []
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_assinante'];

      if(this.pageIsUpd){
        this.title = this.func.traduzir('front.editarAssinante');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarAssinante') : this.func.traduzir('front.cadastrarNovoAssinante');
      }

      this.usuariosService.get()
        .subscribe(
          json => {
            this.listUsuarios = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });


      if (!id) {
        this.atualizaListMercadorias(true);
        return;
      }

      this.srcImgAssinatura = this.global.dominio_site + '/assinaturas/' + id + '.png?t=' + new Date().getTime();
      this.urlUploadAssinatura = this.global.dominio_site + '/adm/assinantes/upload-assinatura/' + id;
      this.urlUploadCertificado = this.global.dominio_site + '/adm/assinantes/upload-certificado/' + id;


      this.assinantesService.getById(id, ['assina_mercadorias'])
        .subscribe(
          json => {

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }

            this.assinante = json.Payload[0];

            this.atualizaListMercadorias(false);

            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarAssinante')+': '+json.Payload[0].usuario.nome;
            }else{
              this.title = this.func.traduzir('front.visualizarAssinante')+': '+json.Payload[0].usuario.nome;
            }

          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }


  voltar() {
    this._location.back();
  }

  save() {
    let result,
      values = this.assinante;

    values['assinar_mercadorias'] = this.listMercadorias;

    this.enviandoForm = true;

    if (values.id_assinante) {
      result = this.assinantesService.editar(values, values.id_assinante);
    } else {
      result = this.assinantesService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'assinantes']),
      error => {
        let json = error.json();
        this.func.showErro(json);

        this.enviandoForm = false;

        for(let i in json.Message.ErrorInput){
          let erro = {};
          erro[i] = json.Message.ErrorInput[i];
          this.form.controls[i].setErrors(erro);
        }
      });
  }

  uploadImgComplete(resp){
    try {
      let json = typeof resp === 'string' ? JSON.parse(resp) : resp;
      if (json && json.Success === false) {
        this.func.showErro(json);
      } else {
        if (json && json.Message) {
          this.func.showSucesso(json.Message);
        }
        this.srcImgAssinatura = this.global.dominio_site + '/assinaturas/' + this.assinante.id_assinante + '.png?t=' + new Date().getTime();
      }
    } catch(e) {
      this.srcImgAssinatura = this.global.dominio_site + '/assinaturas/' + this.assinante.id_assinante + '.png?t=' + new Date().getTime();
    }
  }

  uploadCertificadoComplete(resp){
    try
    {
      let json = JSON.parse(resp);

      if(!json.Success){
        this.func.showErro(json);
      }else{
        this.assinante.com_certificado = true;
      }
    }
    catch(e){}
  }

  deletaCertificado(){

    let self = this;

    let assinantesService = this.assinantesService;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarCertificado'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        assinantesService.deletarCertificado(self.assinante.id_assinante)
          .subscribe(res => {
              self.assinante.com_certificado = false;
            },
            err => {
              self.func.showErro(err.json());
            });

      });

  }


  atualizaListMercadorias(tudoFalse = false){
    this.mercadoInternoMercadoriasService.get()
      .subscribe(
        json => {

          this.listMercadorias = [];

          for(let i in json.Payload){

            let control: FormControl = new FormControl('pode_ssinar'+i, []);
            this.form.setControl('pode_ssinar'+i, control);

            let pode_assinar = false;

            if(!tudoFalse){
              for(let z in this.assinante['assina_mercadorias']){
                if(this.assinante['assina_mercadorias'][z].id_mercadoria == json.Payload[i].id){
                  pode_assinar = true;
                }
              }
            }

            this.listMercadorias.push({
              "id_mercadoria": json.Payload[i].id,
              "nome_pt": json.Payload[i].nome_pt,
              "pode_assinar": pode_assinar
            });
          }

          this.carregandoTabela = false;

          if(this.global.debug == true){
            console.log(json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/assinantes/assinantes-form.component.ts